module.exports = __webpack_public_path__ + "img/web.fa343f46.svg";